import { render } from "./AddMagasin.vue?vue&type=template&id=4a12c55f&ts=true"
import script from "./AddMagasin.vue?vue&type=script&lang=ts"
export * from "./AddMagasin.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__